import React, { createContext, useCallback, useContext, useRef, useState } from 'react';
import { CREAM, INK } from '../theme';

const ToastContext = createContext(null);
let nextId = 1;

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const timers = useRef({});

  const dismiss = useCallback((id) => {
    setToasts((t) => t.filter((x) => x.id !== id));
    clearTimeout(timers.current[id]);
    delete timers.current[id];
  }, []);

  const push = useCallback((message, type) => {
    const id = nextId++;
    setToasts((t) => [...t, { id, message, type }]);
    timers.current[id] = setTimeout(() => dismiss(id), 4000);
  }, [dismiss]);

  const toast = {
    success: useCallback((message) => push(message, 'success'), [push]),
    error: useCallback((message) => push(message, 'error'), [push]),
  };

  return (
    <ToastContext.Provider value={toast}>
      {children}
      <div style={{ position: 'fixed', bottom: 20, right: 20, display: 'flex', flexDirection: 'column', gap: 10, zIndex: 1100, maxWidth: 340 }}>
        {toasts.map((t) => (
          <div
            key={t.id}
            role="status"
            onClick={() => dismiss(t.id)}
            style={{
              fontFamily: "'Cormorant Garamond', serif",
              fontSize: 15,
              lineHeight: 1.4,
              color: CREAM,
              background: INK,
              border: `1px solid ${t.type === 'error' ? '#e08a8a' : '#8fce8f'}`,
              padding: '14px 20px',
              cursor: 'pointer',
              boxShadow: '0 10px 30px rgba(0,0,0,.45)',
            }}
          >
            {t.message}
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used within ToastProvider');
  return ctx;
}
